import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import PayAtHotel, { ProfileType } from '../models/PayAtHotel';

export function getPayAtHotel(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.PAY_AT_HOTEL_DETAIL,
        params: params,
        parser: (data)=> new PayAtHotel(data.data),
    }).get();
}

export function getProfileType() {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.PROFILE_TYPE_LIST,
        parser: profileTypelParser,
    }).get();
}

export function updatePayAtHotel(payAtHotel) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.PAY_AT_HOTEL_UPDATE,
        parser: (data) => new PayAtHotel(data.data),
    }).post(payAtHotel);
}

const profileTypelParser = (data) => (data.data || []).map(item => new ProfileType(item));